import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import moment from 'moment';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Drawer from 'components/Drawer';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import GenerateAudit from '../GenerateAudit';
import { Option, LimitedChipsContainer } from 'components/Options';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import ReactInputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { ModuleAccess } from 'utils/moduleaccess';
import search from "assets/icon/search.svg";
import FormikInputField from 'components/common/Fields/FormikInputField';
import Showerror from "../../../assets/icon/showerror.svg";
import { debounce } from 'lodash';
import reseticon from "assets/icon/reset.svg";









let hasDatePopupOpen = false;


let rowForEdit = {};
let updatedFields = {};

    let coveredEntityError = "Covered Entity is a required field";
    let accumulationError = "Accumulator is a required field";
    let startDateError = "Start Date is a required field";
    let endDateError = "End Date is a required field";
    let accunterror = "Account Type is a required field";
    let auditcounterror = "AuditCount is a required field";

    let coveredEntitiesData = [];
    let accumulationData = [];
    let accountTypeData=[
        { id : 1001 , description : "340B" },
        { id : 1002 , description : "GPO" },
        { id : 1000 , description : "340B and GPO" },
      
    ];

let countoptions = [
    { id : 5000 , description : "All(up to 5000)" },
    { id : 25 , description : "25" },
    { id : 50 , description : "50" },
    { id : 75 , description : "75" },
    { id : 100 , description : "100" },

] 
let strtDate = null;
let enDate = null;
const SearchContainer = (props) => {
    const {
        orgId,
       onsearch,
        addCrosswalk,
        startDateValue,
        endDateValue,
        setEndDate,
        setStartdate,
        onreset,
        auditCreated,
        tableData,
        totalrecords,
        totalAuditRecords,
        selectedviewAudit,
        setSelectedViewAudit,
        setLoading,
        loading,
        reset,
        key,
        ceid,
        setCeid,
        setAuditItems,
        setTotalAuditRecords
    } = props;
    const [isSubmited, serIsSubmitted] = useState(false);
    const [hasACCSelected, setACCSelected] = useState(true);
    const [selectedAccountType, setAccountTypeSelected] = useState(0);
    const [isAuidt,setIsAudit]= useState(false);
    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
      });
      const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
      });
      const [accountType, setAccountType] = useState([]);
      const [hasCESelected, setCESelected] = useState(true);
    const [data, setData] = useState([]);
    const [showDetails,setShowDetails]=useState(true)
    const [collapseSider, setcollapseSider] = useState(false);
    const [error, setError] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [activeButton, setActiveButton] = useState("All");
    // const [loading, setLoading] = useState(false);
    const[generateaudit,setGenerateAudit]=useState(false);
    // const [startDate, setstartDate] = useState(null);
    // const [endDate, setendDate] = useState(null);
    const [count, setCount] = useState("");
    //const [startDateValue, setStartdate] = useState(null);
    //const [endDateValue, setEndDate] = useState(null);
    const [countchecked, setCountChecked] = useState(true);
    const [percentagechecked, setPercentagechecked] = useState(false);
    const [percent, setPercent] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [accuDisabled, setAccuDisabled] = useState(false);
    
    useEffect(()=>{
      setTotalCount(totalrecords);
    },[totalrecords])
    useEffect(()=>{
handelresetkey()
    },[])
    const API = useAxios();
    const {
        states: { searchAudit },
        setStates,
        resetStates,
      } = useContextService();
      const {searchTerms} = searchAudit;

    const updateStates = (searchAudit) => {
        setStates("searchAudit", searchAudit);
      };
    // useEffect(() => {
    //     fetchAccountType();
    // }, []);
    useEffect(() => {
        setCESelected(true);
        setACCSelected(true); 
        setAccuDisabled(false);  
        coveredEntitiesData = [];
        accumulationData = [];
        searchAudit.searchTerms.coveredEntityIDs = {};
        searchAudit.searchTerms.accumulationIDs = {}
        searchAudit.accumulations = [];
        updateStates(searchAudit);
        setCEOptionSelected({ optionCESelected: '-1' });
        setOptionACCSelected({ optionACCSelected: '-1' });
        setAccountTypeSelected(0);
       setStartdate(null);
       setEndDate(null);
       setCount("")
       setPercentagechecked(false)
       setCountChecked(true)
        fetchCoveredEntities();
        serIsSubmitted(false);
      },[orgId]);
      const fetchCoveredEntities = async () => {
        
       // let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            searchAudit.searchTerms.coveredEntityIDs = {};
            updateStates(searchAudit);

            let selectedOrgId = orgId.organizationID;

            setLoading(false);
            try {
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                setLoading(false);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    console.log(data,"Data");
                    searchAudit.coveredEntities = data;
                    
                    if (coveredEntitiesData.length == 1) {
                          var ceData = [];
                          ceData.push(coveredEntitiesData[0])
                          searchAudit.searchTerms.coveredEntityIDs = ceData;
                          window.selectedCoveredEntittyId = ceData;
                          setCeid(ceData)
                      }
                     
                      if (window.selectedCoveredEntittyId.length > 0) {
                        searchAudit.searchTerms.coveredEntityIDs =
                          window.selectedCoveredEntittyId;
                          setCeid(window.selectedCoveredEntittyId)
                      }

                    updateStates(searchAudit);
                    if (searchAudit.searchTerms.coveredEntityIDs) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in searchAudit.searchTerms
                          .coveredEntityIDs) {
                          ceSelected.optionCESelected.push(
                            searchAudit.searchTerms.coveredEntityIDs[x]
                          );
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = searchAudit.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        setCeid(ceIds)
                        fetchAccumulatorName(ceIds);
                    }

                }
            }
            catch (err) {
                setLoading(false);
            }
        }

    };
    const handelPercentage = (e, setFieldValue) => {
      let { value } = e.target;
      setPercent(value);
      searchAudit.searchTerms.percent = value;
      let percentCount = Math.round(totalAuditRecords * (parseInt(value) / 100));
      if (percentCount > 0) {
        setCount(percentCount.toString());
        searchAudit.searchTerms.count = percentCount.toString();
      } else {
        setCount("");
        searchAudit.searchTerms.count = '';
      }
      // setFieldValue("percent", value);
      // setFieldValue("count", percentCount.toString());
  
      updateStates(searchAudit);
    };
    const hasPermission = (code) => {
      return ModuleAccess("ADT", code);
    };
  
  
    // const handleStartDate = (startDate) => {
    //     let stDate = startDate.toISOString();
    //       let dt =  stDate.substring(0,10)
    //      //const formatDate = moment(startDate).format("MM/DD/YYYY");
    //     setstartDate(dt);
    //     //seterror(false);
 
    // };
    // const handleEndDate = (endDate) => {
    //     let stDate = endDate.toISOString();
    //          let dt =  stDate.substring(0,10)
    //     //var dt  = moment(new Date(endDate)).format(
    //     //     'MM/DD/YYYY'        
    //     // );
    //     //const formatDate = moment(endDate).format("MM/DD/YYYY");
    //     setendDate(dt);
    //     //seterror(false);
 
    // };
    const handleEndDate = (endDate) => {
      debugger;
      if (endDate !== null) {
        const date = moment(endDate, "MM/DD/YYYY", true);
        if (date.isValid()) {
          setEndDate(date.toDate());
          enDate = date.toDate();
        }
        setAuditItems([]);
        setCount("");
        setTotalAuditRecords(0);
        handlecount();
      } else {
        setEndDate(null);
          enDate = null;
      }
    };
   
  const handleEndDateRaw = (e) => {
    
      var val = e.target.value;
      if (val == '__/__/____' && endDateValue !== null) {
        setEndDate(null);
        enDate = null;
        // setError(false)
      }
   
      if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
          handleEndDate(e.target.value);
      }
  }
   
    const handleaudit = ()=>{
      setIsAudit(true);
    }
    const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
      let selected = [selectedces == null? []:selectedces]
        handelreset();
      if (selected > [0]) {
          window.selectedCoveredEntittyId = selected;
          window.selectedAccumulatorId = [];
          accumulationData = [];
          // setSelectedNdc('');
          searchAudit.searchTerms.accumulationIDs = {};
          setCESelected(true);
          setCEOptionSelected({
              optionCESelected: selected.value
          });
          let val = selected.value;
          setAccuDisabled(false);
          searchAudit.coveredEntities = selected;
        //   setFieldValue('coveredEntityIDs', selected);
          searchAudit.searchTerms.coveredEntityIDs = selected;
          // if (Array.isArray(searchAudit.searchTerms.coveredEntityIDs)) {
          //     //accumulationIDs = {};
          //     searchAudit.searchTerms.accumulationIDs = {};
          // }
          let ceIds = searchAudit.searchTerms.coveredEntityIDs.map(item => item["value"]);
          searchAudit.searchTerms.coveredEntityIDs = ceIds;
          updateStates(searchAudit);
          setSelectedViewAudit(false)

          fetchAccumulatorName(ceIds);
          setCeid(ceIds)
          setOptionACCSelected({ optionACCSelected: '-1' });
      }
      else {
        //   setFieldValue('coveredEntityIDs', {});
          accumulationData = [];
          searchAudit.coveredEntities = [];
          searchAudit.searchTerms.coveredEntityIDs = {};
          searchAudit.searchTerms.accumulationIDs = {};
          setCESelected(false);
          setOptionACCSelected({
            optionACCSelected: "-1"
        })
          setACCSelected(false);
          // onreset(true)
      }
      updateStates(searchAudit);
    };
    const fetchAccumulatorName = async (coveredEntityIDs) => {
     
      if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
          try {
              accumulationData = [];
              const payload = [];
              payload.AccumulatorEntityList = [coveredEntityIDs[0]];
              let AccumulatorEntityList = [payload.AccumulatorEntityList]
              const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                  {
                      hasDefaultURL: true,
                  }
              );
              if (result) {
                  let accumulator = []
                  accumulator = result.data;
                  for (var x in accumulator) {
                      accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                  }
                 
                  if (accumulationData.length == 1) {
                    handleAccumulatorname(accumulationData[0]);
                    setAccuDisabled(true);
                  }
                  //  else if (window.selectedAccumulatorId.length > 0) {
                  //   searchAudit.searchTerms.accumulationIDs =
                  //     window.selectedAccumulatorId;
                  //     handleAccumulatorname(window.selectedAccumulatorId[0]);
                  // }
                  searchAudit.accumulations = result.data;
                  updateStates(searchAudit);
                  // if (accumulationIDs.length > 0) {
                  //     var accumulatorSelected = {};
                  //     accumulatorSelected.optionACCSelected = [];
                  //     for (var x in accumulationIDs) {
                  //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                  //     }
                  //     setOptionACCSelected({ accumulatorSelected});
                  // }
              }
          } catch (error) {
              console.log(error.message);
          }
      }
  };
  const handleStartDateRaw = (e) => {
    
    var val = e.target.value;
    if (val == '__/__/____' && startDateValue !== null) {
       setStartdate(null);
       strtDate = null;
      //  setError(false)
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
        handleStartDate(e.target.value);
    }
}
 
const handleStartDate = (startDate) => {
  if (startDate !== null) {
    const date = moment(startDate, "MM/DD/YYYY", true);
    if (date.isValid()) {
      setStartdate(date.toDate());
      strtDate = date.toDate();
    }
    setAuditItems([]);
    setCount("");
    setTotalAuditRecords(0);
    handlecount();
  } else {
    setStartdate(null);
    strtDate = null;
  }
}; 
 
    const handleAccumulatorname = (selectedces, setFieldValue, ac) => {
      
      let selected = [selectedces == null?[]:selectedces]
      window.selectedAccumulatorId = selected;
      if (selected > [0]) {
          setACCSelected(true);
          setOptionACCSelected({
              optionACCSelected: selected
          })
          let val = selected.value;
          setAccuDisabled(true);
        //   setFieldValue('accumulatorID', val);
        //   setFieldValue('accumulationIDs', selected);
          searchAudit.searchTerms.accumulationIDs = selected;
          handlecount()

          // handleSearch();
      }
      else {
          setACCSelected(true);
        //   setFieldValue('accumulationIDs', {});
          accumulationData = [];
          searchAudit.coveredEntities = [];
          searchAudit.searchTerms.accumulationIDs = {};
          searchAudit.searchTerms.coveredEntityIDs = {};
          setCESelected(false);
      }
      updateStates(searchAudit);
    
    };
  
    const handleAccountTypeChange = (e) => {
      
      const { value } = e.target;
      setAccountTypeSelected(value);
      searchAudit.searchTerms.accountType = value;
      // accumulationData=[];
      setAuditItems([]);
      setCount("");
      setTotalAuditRecords(0);
      updateStates(searchAudit);
      handlecount();
     
  };

    const togglegenerateAudit= () => {
        setGenerateAudit(!generateaudit);
      };
    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }
    const handelAddCrosswalk=async()=>{
        await addCrosswalk()
    }

   
    const renderEditButton = () => {
         if (hasPermission('ED'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => ""}
                title='Edit Covered Entity'

            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const cellRenderEdit = (rowData) => {

        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'

                onClick={() => editRow(rowData)}
                title='Edit'


            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const editRow = (rowData, isEdit = true) => {

        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        // setTouched('');
        // setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {
    };
    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };

    const handelAdd=()=>{
        setShowDetails(false)
    }
    const handelCancel=()=>{
        setShowDetails(true)
    }
    useEffect(()=>{

    },[showDetails])
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleButtonClick = (button) => {
      setActiveButton(button);
    };
    const handleauditc =  (e) => {
      setCount(e.target.value);
      searchAudit.searchTerms.count = e.target.value;
      // setFieldValue("count", e.target.value);
      updateStates(searchAudit);
    };
    const handlesubmit = async() => {
        
      let ceIDs=[]
      let values = {};
      let acids = [];
      setSelectedViewAudit(false)
      console.log(selectedviewAudit,"selected")

      for (var x in searchTerms.accumulationIDs) {
        let rw = searchTerms.accumulationIDs[x];
        acids.push(rw.value);
      }
      for (var x in searchTerms.coveredEntityIDs) {
        let rw = searchTerms.coveredEntityIDs[x];
        ceIDs.push(rw.value);
      }
      values.acids  = acids;
      var validationFlag= false;
      if (ceIDs.length == 0 && acids.length == 0) {
      setCESelected(false);
      setACCSelected(false)
        validationFlag=true;
      }
      if(ceIDs.length > 0 && acids.length == 0){
        setACCSelected(false);
       validationFlag=true;
      }
      if(startDateValue == null || endDateValue == null || searchAudit.searchTerms.accountType == 0  || count == "" || parseInt(count) > 10000){
        return setError(true);
        validationFlag=true;
      }
      if(validationFlag){
        return true
      }


      values.startDate = startDateValue;
      values.endDate = endDateValue;
      values.accountType = searchAudit.searchTerms.accountType;
      values.count =count;
      
     await  onsearch(values,'auditdata');
    };
    const handlecount = async() => {
      
    let ceIDs=[]
    let values = {};
    let acids = [];
    setSelectedViewAudit(false)
    console.log(selectedviewAudit,"selected")

    for (var x in searchTerms.accumulationIDs) {
      let rw = searchTerms.accumulationIDs[x];
      acids.push(rw.value);
    }
    for (var x in searchTerms.coveredEntityIDs) {
      let rw = searchTerms.coveredEntityIDs[x];
      ceIDs.push(rw.value);
    }
    values.acids  = acids;
    if (ceIDs.length == 0 && acids.length == 0) {
    setCESelected(false);
    setACCSelected(false)
      return true;
    }
    if(ceIDs.length > 0 && acids.length == 0){
      setACCSelected(false);
     return true;
    }
    
    if(startDateValue != null && endDateValue != null && searchAudit.searchTerms.accountType != 0 ){
    values.startDate = moment(new Date(strtDate)).format("MM/DD/YYYY");
    values.endDate =moment(new Date(enDate)).format("MM/DD/YYYY"); 
    values.accountType = searchAudit.searchTerms.accountType;
    values.count = count;
    
   await onsearch(values,'countdata');
    }
  };
const handleSearch =async ()=>{
  
  let values = {};
  let acids = [];
  for (var x in searchTerms.accumulationIDs) {
    let rw = searchTerms.accumulationIDs[x];
    acids.push(rw.value);
  }
  values.acids  = acids;
  await  onsearch(values,'alldata');

}
const handelcountchecked = () => {
  setCountChecked(true);
  setPercentagechecked(false);
  setPercent("");
  setCount("");
};
const handelPercentagechecked = () => {
  setPercentagechecked(true);
  setCountChecked(false);
  setPercent("");
  setCount("");
};

    // const handelreset=async()=>{
    //   setPercentagechecked(false);
    //   setCountChecked(false);
    //   setPercent("");
    //   setCount("");
    //   se
    // }
    const handelreset =async () => {
      setPercentagechecked(false);
       setCountChecked(true);
       setPercent("");
       setCount("");
      serIsSubmitted(false);
      setCESelected(true);
      setACCSelected(true);
      accumulationData=[];
      window.selectedCoveredEntittyId = "";
      window.selectedAccumulatorId = "";
      // resetForm();
      setError(false);
      setEndDate(null),
      setStartdate(null),
      setCEOptionSelected({ optionCESelected: "-1" });
      setOptionACCSelected({ optionACCSelected: "-1" });
      // searchAudit.s
      searchAudit.searchTerms.coveredEntityIDs = {};
      searchAudit.searchTerms.accumulationIDs = {};
      searchAudit.searchTerms.startDate=null
      searchAudit.searchTerms.endDate=null
      searchAudit.searchTerms.accountType=0
      setAccountTypeSelected(0)
      updateStates(searchAudit);


  await reset()
  }
  const handelresetkey =async () => {
    setPercentagechecked(false);
     setCountChecked(true);
     setPercent("");
   setCount("");
    serIsSubmitted(false);
    setCESelected(true);
    setACCSelected(true);
    accumulationData=[];
    // searchAudit.s
    setAccountTypeSelected(0);
    setEndDate(null);
    setStartdate(null);
    setTotalCount(0)
}
  return (
    
    <div>
        <h5 className="f-16 text-primary font-weight-700">
              Search New Audit
            </h5>

        <Formik
                             initialValues={''}
                            onSubmit={handlesubmit}
                            // validationSchema={validationSchema}
                            // enableReinitialize={true}
                            children={(props) => {
                             const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                  <div hidden={collapseSider}>
                                    <div>
                                      <Row sm={5} className="d-flex" style={{}}>
                                        <Col md={3} lg={3} sm={6} xs={6}>
                                          {" "}
                                          <FormGroup>
                                            <Label for="coveredentity">
                                              Covered Entity
                                            </Label>
                                            <ReactSelect
                                              name="coveredentity"
                                              id="coveredentity"
                                              options={coveredEntitiesData}
                                              //isMulti
                                              closeMenuOnSelect={true}
                                              hideSelectedOptions={false}
                                              optionSelected={false}
                                              //isClearable = {true}
                                              components={{
                                                Option,
                                              }}
                                              isSearchable="true"
                                              onChange={(value, entity) =>
                                                handleCoverdEntityChange(
                                                  value,
                                                  setFieldValue,
                                                  entity
                                                )
                                              }
                                              value={
                                                selectedCEOption.optionCESelected
                                              }
                                              className="claim_info required"
                                              maxMenuHeight={220}
                                              styles={{
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 99,
                                                }),
                                                option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                              }}
                                            />
                                            {!hasCESelected ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {coveredEntityError}
                                              </div>
                                            ) : null}
                                          </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3} sm={6} xs={6}>
                                          {" "}
                                          <FormGroup>
                                            <Label for="accumulator">
                                              Accumulator
                                            </Label>
                                            <ReactSelect
                                              name="accumulator"
                                              id="accumulator"
                                              options={accumulationData}
                                              //isMulti
                                              closeMenuOnSelect={true}
                                              hideSelectedOptions={false}
                                              optionSelected={true}
                                              isDisabled={
                                                accumulationData.length == 1
                                              }
                                              components={{
                                                Option,
                                              }}
                                              onChange={(value, ac) =>
                                                handleAccumulatorname(
                                                  value,
                                                  setFieldValue,
                                                  ac
                                                )
                                              }
                                              value={
                                                selectedACCOption.optionACCSelected
                                              }
                                              isSearchable="true"
                                              className="claim_info required"
                                              maxMenuHeight={220}
                                              styles={{
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 99,
                                                }),
                                                option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                                              }}
                                            />
                                            {!hasACCSelected &&
                                            selectedACCOption.optionACCSelected ==
                                              "-1" ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {accumulationError}
                                              </div>
                                            ) : null}
                                          </FormGroup>
                                        </Col>
                                        {/* <Col md={3}  lg={3} sm={6} xs={6} style={{zIndex:99}}  >
                                {' '}
                                <FormGroup>
                                <Label for='startdate'>From Date

                                </Label>
                                <InputGroup onMouseLeave={handleMouseLeave}>
                                                <Field
                                                    type='text'
                                                    id='startdate'
                                                    name='startdate'
                                                    autoComplete='off'
                                                    placeholder='Select  Effective Date'
                                                className="w-100"
                                                    value={startDate}
                                                    component={FormikDatePicker}
                                                    onChange={handleStartDate}
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('startDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>

                                                                        

                                </FormGroup>
                                
                               

                            </Col> */}
                                        <Col md={3} className="required-date">
                                          <FormGroup>
                                            <Label></Label>
                                            <Label
                                            // htmlFor="StartDate" for='reportname'
                                            // className={focusedInput === 'StartDate' ? 'label-focus' : ''}
                                            >
                                              Start Date
                                            </Label>
                                            <InputGroup
                                              onMouseLeave={handleMouseLeave}
                                            >
                                              {/* <Field
                                                            setcss="required"
                                                            type='text'
                                                            id='StartDate'
                                                            name='StartDate'
                                                            autoComplete='off'
                                                            placeholder='Select a date'
                                                            value={startDateValue}
                                                            component={FormikDatePicker}
                                                            onChange={handleStartDate}
                                                            onFocus={() => handleFocus('StartDate')}
                                                            onBlur={handleBlur}
                                                        /> */}
                                              <DatePicker
                                                id="startDate"
                                                name="startDate"
                                                selected={startDateValue}
                                                onChange={(startDate) =>
                                                  handleStartDate(startDate)
                                                }
                                                //  onFocus={() => handleFocus('StartDate')}
                                                //  onBlur={handleBlur}
                                                maxDate={
                                                  endDateValue || new Date()
                                                }
                                                isClearable
                                                onChangeRaw={handleStartDateRaw}
                                                dateFormat="MM/dd/yyyy"
                                                placeholderText="Select a date"
                                                autoComplete="off"
                                                customInput={
                                                  <ReactInputMask
                                                    mask="99/99/9999"
                                                    value={startDateValue}
                                                    // maskChar=''
                                                  />
                                                }
                                              />
                                              <InputGroupText
                                                onClick={() =>
                                                  handleDateClick("startDate")
                                                }
                                              >
                                                <img src={Calendar} alt="" />
                                              </InputGroupText>
                                            </InputGroup>
                                            {error && startDateValue == null ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {startDateError}
                                              </div>
                                            ) : null}
                                          </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                          <FormGroup>
                                            <Label></Label>
                                            <Label
                                              htmlFor="EndDate"
                                              for="reportname"
                                              // className={focusedInput === 'EndDate' ? 'label-focus' : ''}
                                            >
                                              End Date
                                            </Label>
                                            <InputGroup
                                              onMouseLeave={handleMouseLeave}
                                              className="required-date"
                                            >
                                              {/* <Field
                                                            setcss="required"
                                                            type='text'
                                                            id='EndDate'
                                                            name='EndDate'
                                                            autoComplete='off'
                                                            placeholder='Select a date'
                                                            value={endDateValue}
                                                            component={FormikDatePicker}
                                                            onChange={handleEndDate}
                                                            onFocus={() => handleFocus('EndDate')}
                                                            onBlur={handleBlur}
                                                        /> */}
                                              <DatePicker
                                                id="endDate"
                                                name="endDate"
                                                //  onFocus={() => handleFocus('EndDate')}
                                                //  onBlur={handleBlur}
                                                selected={endDateValue}
                                                // minDate={startDateValue}
                                                maxDate={new Date()}
                                                minDate={
                                                  startDateValue
                                                    ? startDateValue
                                                    : null
                                                }
                                                onChange={handleEndDate}
                                                onChangeRaw={handleEndDateRaw}
                                                dateFormat="MM/dd/yyyy"
                                                // dateFormat="yyyy/mm/dd"

                                                placeholderText="Select a date"
                                                autoComplete="off"
                                                customInput={
                                                  <ReactInputMask
                                                    mask="99/99/9999"
                                                    value={endDateValue}
                                                    // maskChar=''
                                                  />
                                                }
                                              />
                                              <InputGroupText
                                                onClick={() =>
                                                  handleDateClick("endDate")
                                                }
                                              >
                                                <img src={Calendar} alt="" />
                                              </InputGroupText>
                                            </InputGroup>
                                            {error && endDateValue == null ? (
                                              <div className="text-danger f-12">
                                                {endDateError}
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            {/* {(error) && startDateValue > endDateValue?<div className="text-danger f-12">
                                                        StartDate should be greater than EndDate or Null</div>:''} */}
                                          </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3} sm={6} xs={6}>
                                          {" "}
                                          <FormGroup>
                                            <Label for="accounttype">
                                              Account Type
                                            </Label>
                                            <Input
                                              name="accounttype"
                                              id="accounttype"
                                              type="select"
                                              className="claim_info required"
                                              value={selectedAccountType}
                                              //component={FormikSelectField}
                                              onChange={handleAccountTypeChange}
                                            >
                                              <option value={0}>
                                                Select...
                                              </option>
                                              {accountTypeData.map(
                                                (accountT) => {
                                                  const { id, description } =
                                                    accountT;
                                                  return (
                                                    <option key={id} value={id}>
                                                      {description}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </Input>
                                            {error && selectedAccountType == 0 ? (
                                            <div className="text-danger f-12 position-absolute">
                                              {accunterror}
                                            </div>
                                          ) : null}
                                          </FormGroup>
                                        </Col>
                                        <Col md={3} sm={3} xs={6}>
                                          <FormGroup>
                                            <Label for="drugManufacturerID">
                                              Select Operator
                                            </Label>
                                            <div className="d-flex">
                                              <div>
                                                <Input
                                                  type="radio"
                                                  checked={countchecked}
                                                  // disabled={auditCreated}
                                                  onClick={handelcountchecked}
                                                  color="primary"
                                                  name="radio1"
                                                />{" "}
                                                <strong> Flat</strong>
                                              </div>
                                              <div className="ms-2">
                                                <Input
                                                  type="radio"
                                                  // disabled={auditCreated}
                                                  onClick={
                                                    handelPercentagechecked
                                                  }
                                                  color="primary"
                                                  checked={percentagechecked}
                                                  name="radio1"
                                                />{" "}
                                                <strong> Percentage </strong>
                                              </div>
                                            </div>
                                            {countchecked == true ||
                                            percentagechecked == true ? (
                                              <div
                                                className="p-2 "
                                                style={{
                                                  backgroundColor: "#DBCAD8",
                                                  color: "#702C62",
                                                  borderRadius: "8px",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                <span className="">
                                                  <img src={Showerror}></img>
                                                  <span className="ms-1">
                                                    Max. of 5,000 records to be
                                                    pulled
                                                  </span>
                                                </span>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </FormGroup>
                                        </Col>
                                        {percentagechecked == true && (
                                          <Col md={3} sm={3} xs={6}>
                                            <FormGroup>
                                              <Label for="auditPercent">
                                                Audit Percentage
                                              </Label>
                                              <Input
                                                name="auditPercent"
                                                type="text"
                                                maxLength="3"
                                                autoComplete="off"
                                                // disabled={auditCreated}
                                                onKeyPress={(e) =>
                                                  (e.target.value.length > 3 ||
                                                    !/[0-9]/.test(e.key)) &&
                                                  e.preventDefault()
                                                }
                                                value={percent}
                                                onChange={(e) =>
                                                  handelPercentage(e)
                                                }
                                                component={FormikInputField}
                                              />
                                              {parseInt(percent) > 100 ? (
                                                <div className="text-danger f-12 position-absolute">
                                                  Percentage should be less than
                                                  100
                                                </div>
                                              ) : null}
                                            </FormGroup>
                                          </Col>
                                        )}
                                        <Col md={3} sm={3} xs={6}>
                                          <FormGroup>
                                            <Label for="auditcount">
                                              Audit Count (
                                              <strong>Records :</strong>{" "}
                                              {totalAuditRecords ?? 0})
                                            </Label>
                                            <Input
                                              className="claim_info required"
                                              name="auditcount"
                                              type="text"
                                              maxLength="5"
                                              autoComplete="off"
                                              disabled={percentagechecked}
                                              onKeyUp={(e) =>
                                                (e.target.value.length > 5 ||
                                                  !/[0-9]/.test(e.key)) &&
                                                e.preventDefault()
                                              }
                                              value={count}
                                              onChange={(e) => handleauditc(e)}
                                              component={FormikInputField}
                                            />
                                            {error &&
                                            (count == "" ||
                                              parseInt(count) > 5000) ? (
                                              count == "" ? (
                                                <div className="text-danger f-12 position-absolute">
                                                  {percentagechecked == true
                                                    ? "Audit Percentage is a required field"
                                                    : "Audit Count is a required field"}
                                                </div>
                                              ) : (
                                                <div className="text-danger f-12 position-absolute">
                                                  Audit Count should be less
                                                  than 5,000
                                                </div>
                                              )
                                            ) : null}
                                            </FormGroup>
                            </Col>
                                          
                            {/* <Col md={3}  lg={3} sm={6} xs={6} style={{zIndex:99}} >
                                {' '}
                                <FormGroup>
                                <Label>To Date

                                </Label>
                                <InputGroup onMouseLeave={handleMouseLeave}>
                                                <Field
                                                    type='text'
                                                    id='endDate'
                                                    name='endDate'
                                                    autoComplete='off'
                                                    placeholder='Select  EndDate '
                                                    className="w-100"
                                                    value={endDate}
                                                    component={FormikDatePicker}
                                                    onChange={handleEndDate}
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('endDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>

                                                                        

                                </FormGroup>
                                
                               

                            </Col> */}

                                        {/* <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Audit Count'>Audit Count </Label>
                                  <Input type='select'  className="claim_info required" name='count' value={count} onChange={handleauditc}>
                                
                                              {countoptions.map(
                                                (accountT) => {
                                                  const { id, description } =
                                                    accountT;
                                                  return (
                                                    <option key={id} value={id}>
                                                      {description}
                                                    </option>
                                                  );
                                                }
                                              )}
                              
                                  </Input>
                                </FormGroup>
                            </Col> */}
                                      </Row>
                                    </div>
                                    <div hidden={""}>
                                      <Row
                                        style={{ justifyContent: "flex-end" }}
                                      >
                                        <Col
                                          md="auto"
                                          className="d-flex justify-content-end"
                                        >
                                          {/* <Button
                                   
                                   color="primary"
                                   className=""
                                   onClick={handleSearch}
                                   disabled={isAuidt}
                               >
                                   search
                               </Button> */}
                                          {/* <Button
                                   
                                    color="primary"
                                    className=""
                                    onClick={handleaudit}
                                    hidden={isAuidt}
                                >
                                    Audit
                                </Button> */}
                                          <Button
                                            color="primary"
                                            className="search"
                                            onClick={handlesubmit}
                                            hidden={!hasPermission("AD")}
                                            // hidden={!isAuidt}
                                          >
                                            <span className="right_5">
                                              <img src={search} alt="" />
                                            </span>{" "}
                                            Generate Audit
                                          </Button>
                                          <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="reset"
                                            onClick={handelreset}
                                            // disabled={!coveredEntityid}
                                            // hidden={!hasPermission("ADD")}
                                          >
                                            <span className="right_5">
                                              <img src={reseticon} alt="" />
                                            </span>{" "}
                                            Reset
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                );
                            }}></Formik>
                          
                        <Drawer
        direction="end"
        title="Generate Audit"
        isOpen={generateaudit}
        toggle={togglegenerateAudit}
        size="lg"
      >
        <GenerateAudit startDate={startDateValue}/>
      </Drawer>
                       


    </div>
  )
}

export default SearchContainer
